import React from 'react';
import { ROBO, CREDIT_CARD } from '../../constants/userProfile';
import CreditCardSuccess from 'components/CreditCardComponents/CreditCardSuccess/CreditCardSuccess';
import RoboSuccess from 'components/EnrolmentSuccess/RoboSuccess';
import TraditionalSuccess from 'components/EnrolmentSuccess/TraditionalSuccess';

export const EnrolmentSuccess = ({ investmentType }) => {
    const VIEW_BY_INVESTMENT_TYPE = {
        [CREDIT_CARD]: <CreditCardSuccess />,
        [ROBO]: <RoboSuccess />,
    };

    return <div>{VIEW_BY_INVESTMENT_TYPE[investmentType] || <TraditionalSuccess />}</div>;
};
